import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { listings } from '../../actions'
import routeHelpers from '../../helpers/routeHelpers'
import ConfigContext from '../../contexts/configContext'
import { trackEvent } from '../../withTracking'
import trackingEvents from '../../constants/trackingEvents'

const {
  CATEGORY_LISTING,
  ACTION_STAR
} = trackingEvents

const FavouriteIndicator = ({
  listingUuid
}) => {
  const { isLoginModuleEnabled } = React.useContext(ConfigContext)
  const location = useLocation()
  const listingId = useSelector(state => state.lots.listings[listingUuid]?.id)
  const isMarketplace = useSelector(state => state.lots.listings[listingUuid]?.isMarketplace)
  const auctionUuid = useSelector(state => isMarketplace ? 'marketplace' : state.lots.listings[listingUuid]?.auctionUuid)
  const isFavourited = useSelector(state => state.lots.favourites[auctionUuid]?.[listingUuid])
  const userId = useSelector(state => state.users.user.id)
  const dispatch = useDispatch()
  if (!listingId) return null

  const loginUrlWithoutRegistration = userId
    ? null
    : isLoginModuleEnabled === true
      ? `/login?redirect=${encodeURIComponent(location.pathname)}`
      : isLoginModuleEnabled

  const authProtectedAction = (loginUrlWithoutRegistration)
    ? () => routeHelpers.navigate(loginUrlWithoutRegistration)
    : false

  const toggleFavourite = () => {
    if (userId) {
      dispatch(listings.favouriteToggle(auctionUuid, listingUuid, listingId, userId))
      trackEvent(CATEGORY_LISTING, ACTION_STAR, listingUuid)
    } else {
      authProtectedAction()
    }
  }

  return (
    <button
      onClick={toggleFavourite}
      className={`lot__watch a11y__interactive--button pull-right float-right ${isFavourited ? 'lot__watch--watched' : ''}`}
      aria-label='Star Item'
    >
      <FontAwesomeIcon icon={faStar} />
    </button>
  )
}

FavouriteIndicator.propTypes = {
  listingUuid: PropTypes.string.isRequired
}

export const FavouriteIndicatorWithoutMemo = FavouriteIndicator

export default React.memo(FavouriteIndicator)
